import React from 'react';
import { motion } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'; // أضف هذا الاستيراد
import './InsuranceCard.css';

const InsuranceCard = ({ insurance, index }) => {
  const { currentLanguage } = useSelector((state) => state.language);
  const navigate = useNavigate(); // أضف هذا
  
  const icons = {
    'Compulsory Car Insurance': '🚗',
    'Complementary Car Insurance': '🚙',
    'Travelers Insurance': '✈️',
    'Aviation Insurance': '🛩️',
    'Fire Insurance': '🔥',
    'Energy Insurance': '⚡',
    'Engineering Insurance': '🏗️',
    'Personal Accident Insurance': '🚑',
    'Medical Insurance': '🏥',
    'Social Takaful Insurance': '🕌',
    'Miscellaneous Accidents (Properties)': '🏘️',
    'Miscellaneous Accidents (Liabilities)': '⚖️',
    'Objects Insurance': '📦',
  };
  
  const insuranceData = {
    'Compulsory Car Insurance': {
      icon: icons['Compulsory Car Insurance'],
      category: 'vehicle',
      description: {
        en: 'Mandatory coverage for all vehicles in Libya',
        ar: 'تغطية إلزامية لجميع المركبات في ليبيا'
      }
    },
    'Complementary Car Insurance': {
      icon: icons['Complementary Car Insurance'],
      category: 'vehicle',
      description: {
        en: 'Additional protection beyond compulsory insurance',
        ar: 'حماية إضافية تتجاوز التأمين الإلزامي'
      }
    },
    'Travelers Insurance': {
      icon: icons['Travelers Insurance'],
      category: 'travel',
      description: {
        en: 'Protection during your journeys worldwide',
        ar: 'حماية خلال رحلاتك حول العالم'
      }
    },
    'Aviation Insurance': {
      icon: icons['Aviation Insurance'],
      category: 'aviation',
      description: {
        en: 'Comprehensive coverage for aircraft and liabilities',
        ar: 'تغطية شاملة للطائرات والمسؤوليات'
      }
    },
    'Fire Insurance': {
      icon: icons['Fire Insurance'],
      category: 'property',
      description: {
        en: 'Protection against fire damage to properties',
        ar: 'حماية ضد أضرار الحريق للممتلكات'
      }
    },
    'Energy Insurance': {
      icon: icons['Energy Insurance'],
      category: 'energy',
      description: {
        en: 'Specialized coverage for energy sector risks',
        ar: 'تغطية متخصصة لمخاطر قطاع الطاقة'
      }
    },
    'Engineering Insurance': {
      icon: icons['Engineering Insurance'],
      category: 'engineering',
      description: {
        en: 'Coverage for construction and engineering projects',
        ar: 'تغطية لمشاريع البناء والهندسة'
      }
    },
    'Personal Accident Insurance': {
      icon: icons['Personal Accident Insurance'],
      category: 'personal',
      description: {
        en: 'Financial protection against accidental injuries',
        ar: 'حماية مالية ضد الإصابات العرضية'
      }
    },
    'Medical Insurance': {
      icon: icons['Medical Insurance'],
      category: 'health',
      description: {
        en: 'Comprehensive healthcare coverage',
        ar: 'تغطية صحية شاملة'
      }
    },
    'Social Takaful Insurance': {
      icon: icons['Social Takaful Insurance'],
      category: 'takaful',
      description: {
        en: 'Sharia-compliant cooperative insurance',
        ar: 'تأمين تعاوني متوافق مع الشريعة الإسلامية'
      }
    },
    'Miscellaneous Accidents (Properties)': {
      icon: icons['Miscellaneous Accidents (Properties)'],
      category: 'property',
      description: {
        en: 'Coverage for various property-related accidents',
        ar: 'تغطية لمختلف الحوادث المتعلقة بالممتلكات'
      }
    },
    'Miscellaneous Accidents (Liabilities)': {
      icon: icons['Miscellaneous Accidents (Liabilities)'],
      category: 'liability',
      description: {
        en: 'Protection against third-party liability claims',
        ar: 'حماية ضد مطالبات المسؤولية تجاه الغير'
      }
    },
    'Objects Insurance': {
      icon: icons['Objects Insurance'],
      category: 'property',
      description: {
        en: 'Coverage for valuable objects and assets',
        ar: 'تغطية للأشياء والممتلكات القيمة'
      }
    },
  };
  
  const data = insuranceData[insurance] || {
    icon: '🛡️',
    category: 'all',
    description: { en: 'Comprehensive insurance coverage', ar: 'تغطية تأمينية شاملة' }
  };
  
  // دالة للانتقال إلى صفحة الخدمات مع فلترة القسم المحدد
  const handleLearnMore = () => {
    // حفظ نوع التأمين المحدد في localStorage للوصول إليه في صفحة الخدمات
    localStorage.setItem('selectedInsurance', insurance);
    
    // الانتقال إلى صفحة الخدمات
    navigate('/services');
    
    // بعد الانتقال، قم بفلترة الخدمات حسب النوع
    setTimeout(() => {
      // البحث عن الزر المناسب في صفحة الخدمات
      const categoryBtn = document.querySelector(`[data-category="${data.category}"]`);
      if (categoryBtn) {
        categoryBtn.click(); // تفعيل الفلتر
      }
      
      // التمرير لبداية قائمة الخدمات
      const servicesSection = document.querySelector('.services-list');
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };
  
  return (
    <motion.div 
      className="insurance-card"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -10, scale: 1.02 }}
    >
      <div className="card-icon">
        <motion.span
          animate={{ rotate: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          {data.icon}
        </motion.span>
      </div>
      <h3 className="card-title">{insurance}</h3>
      <p className="card-description">{data.description[currentLanguage]}</p>
      <motion.button 
        className="card-button"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleLearnMore}
      >
        {currentLanguage === 'en' ? 'Learn More' : 'تعرف أكثر'}
      </motion.button>
    </motion.div>
  );
};

export default InsuranceCard;